export default __webpack_public_path__ + "static/media/logo-cutilei-simple.55094bf3.png";